// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"80bbbc22","355":"19b66f0e","442":"d90539d6","740":"d310eca3","974":"81397fc4"}[chunkId] + ".chunk.js";
};